<template>


        <v-card 
        elevation="2"
        shaped
        class="ma-1"
        >
        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> Paramétrages généraux </v-tab>
          <v-tab> requetes pour jonction </v-tab>
          <v-tabs-items v-model="tab" class="pl-4">
            <v-tab-item>
                <v-row>
                    <v-col class="ma-1">
              <v-btn @click="openBibliothequeModule('new')"
                >Créer un module bibliothèque</v-btn>                      
                        <Select
                        :item="item"
                        :change="(item,value) => { displays.params.bibliothequemodule = value.value}"
                        :valField="displays.params.bibliothequemodule"
                        />  

                        <TextField                  
                        :item="{name:'id du fichier',value:'file_id',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {displays.params.file_id = value } "
                        :valField="displays.params.file_id"/>

                        <TextField                  
                        :item="{name:'nom du fichier de sortie',value:'file_name',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {displays.params.file_name = value } "
                        :valField="displays.params.file_name"/>

                        <div v-if="displays.params.bibliothequemodule!=''">

              <v-btn @click="openBibliothequeModule(displays.params.bibliothequemodule)"
                >Editer le module bibliothèque</v-btn>

                        <component v-bind:is="$modules.bibliotheque.components.client"
                        :key="displays.params.bibliothequemodule"  
                        :mod="false"
                        :idmodule="displays.params.bibliothequemodule" 
                        :modal="false"
                        :modalKey="modalKey"
                        :page="page"
                        :customparams="{allowselect:true}"
                        :form="false"
                        />                            

                        </div>
                    </v-col>
                </v-row>
            </v-tab-item>

            <v-tab-item>

                <v-btn fab small @click="addListe"><v-icon>mdi-plus</v-icon></v-btn>
                <v-expansion-panels variant="popout" v-model="listQuerys" class="pa-3">
                <v-expansion-panel v-for="(query, i) in displays.params.querys" :key="'lf'+i" v-show="query.key!='default'">
                    <v-expansion-panel-header>
                    {{query.key}} : {{query.description}}
                    <template v-slot:actions>
                        <v-btn icon @click="removeListe(i)" v-if="query.key!='default'"><v-icon>mdi-close-thick</v-icon></v-btn>
                    </template> 
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="grey lighten-3">

                    <div>
                        <TextField                  
                        :item="{name:'clé',value:'key',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {query.key = value } "
                        :valField="query.key"/>
                        <TextField                  
                        :item="{name:'description',value:'description',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {query.description = value } "
                        :valField="query.description"/>
                        <Select
                        :item="{name: 'table ciblée',value: 'table',liste: listTables,
                        defaultprops:{ show: true,clearable:true } } "
                        :change="(item,value) => { query.table = value?.value || ''; } "
                        :valField="query.table"
                        />        
                        <p>requete simple : vous pouvez mettre vos variables ou vous le souhaitez. Le résultat de la requete retournera obligatoirement une seule ligne.</p>
                        <p>requete sur plusieurs lignes : (plusieurs ligne sur résultat de requete) Vous avez l'obligation de mettre ces variables dans un tableau.</p> Créez une seule ligne de tableau dans votre document avec les variables ${ {{ query.key }}.mon_as }  et vous visualiserez autant de lignes qu'il y a de résultats dans la requete        

                        <Select
                        :item="{name: 'type de requete',value: 'typequery',liste: buildingParameters.publipost.listtypequery,
                        defaultprops:{ show: true,clearable:true } } "
                        :change="(item,value) => { query.typequery = value?.value || ''; } "
                        :valField="query.typequery"
                        />       
                    </div>

                    <v-tabs v-model="tabsFiche" v-if="query.table && query.table!=''">
                        <v-tab> Filtre </v-tab>
                        <v-tab> Champs </v-tab>
                        <v-tabs-items v-model="tabsFiche">
                        <v-tab-item>
                            <Filtre :page="page" :filtre="query.filtre" :table="query.table" />
                        </v-tab-item>
                        <v-tab-item> 
                            <Fields :page="page" :champs="query.champs" :modalKey="modalKey" :filter="query.filtre" :table="query.table" />
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>

                    </v-expansion-panel-content>  

                </v-expansion-panel>
                </v-expansion-panels>

            </v-tab-item>


            </v-tabs-items>
        </v-tabs>
        </v-card>



</template>



<script>
import { admin } from '../mixins'; 
import { openModuleEditor } from '@/components/engine/editModule/navigation'
    export default {
        name : 'publiPostWordModule',

        mixins : [admin],

        data: function() {
            return { 
            item : {name:'Module bibliothèque utilisé pour la selection du doc. word',value:'bibliothequemodule',liste:[],
                defaultprops:{show:true,modelRules:[v => !!v || 'Au moins un champ doit etre renseigné']}},

                displays : this.module.displays,
                tab : '',
                listQuerys : '',
                listTables : [],
                tabsFiche : '',
            }
        },

        watch: {
            '$store.getters.getPicture'(val) {
                if (!val || !val.image_url) return

                // éviter de relancer si déjà traité
                if (this.displays.params.file_id === val.image_id) return

                this.displays.params.file_id = val.image_id
                this.displays.params.file_name = val.name
                this.$store.dispatch('removePicture')
            },
        
        },


        methods : {

            openBibliothequeModule(id) {
                openModuleEditor({
                    id,
                    initialType: id === 'new' ? 'bibliotheque' : '',
                    contextKey: this.modalKey,
                    onSaved: module => {
                        if (id === 'new') this.displays.params.bibliothequemodule = module.id
                        this.getBibliModules()
                    },
                })
            },

            addListe() {
            
                var defaultQ = JSON.parse(JSON.stringify(this.buildingParameters.publipost.defaultquery));
                this.displays.params.querys.push(defaultQ);
            },

            removeListe(index) {
                this.displays.params.querys = this.displays.params.querys.filter((el,i)=> i!=index);
            },

            getBibliModules() {
                this.item.liste = []
                this.API({ type: 'post', url: "/engine/module/list", params: { type: 'bibliotheque' } }).then((resp) => {
                    resp.data.forEach((v) => {
                    this.item.liste.push({ value: v.id, text: v.name });
                    });
                })
            }
        },
    
        mounted() { 
            
            this.getBibliModules();

            this.API({type:'get', url:'engine/getlisttable'}).then((resp) => {
                resp.data.forEach((table) => {
                    this.listTables.push({text:table,value:table})
                })
                
            })            
        }

    }

</script>

